'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getByLocale = undefined;

var _seekClassificationsHierarchy = require('@seek/seek-classifications-hierarchy');

var getTaxonomyByLocale = function getTaxonomyByLocale(locale) {
  return {
    'classifications': (0, _seekClassificationsHierarchy.getByLocale)(locale),

    'sortModes': [{
      'label': 'Relevance',
      'value': 'KeywordRelevance'
    }, {
      'label': 'Date',
      'value': 'ListedDate'
    }],
    'workTypes': [{
      'label': 'Full time',
      'value': '242'
    }, {
      'label': 'Part time',
      'value': '243'
    }, {
      'label': 'Contract/Temp',
      'value': '244'
    }, {
      'label': 'Casual/Vacation',
      'value': '245'
    }],
    'salaries': {
      'defaultValue': 'annual',
      'options': [{
        'label': 'Annually',
        'value': 'annual',
        'options': [{
          'label': '$0',
          'value': '0'
        }, {
          'label': '$30k',
          'value': '30000'
        }, {
          'label': '$40k',
          'value': '40000'
        }, {
          'label': '$50k',
          'value': '50000'
        }, {
          'label': '$60k',
          'value': '60000'
        }, {
          'label': '$70k',
          'value': '70000'
        }, {
          'label': '$80k',
          'value': '80000'
        }, {
          'label': '$100k',
          'value': '100000'
        }, {
          'label': '$120k',
          'value': '120000'
        }, {
          'label': '$150k',
          'value': '150000'
        }, {
          'label': '$200k',
          'value': '200000'
        }, {
          'label': '$200k+',
          'value': '999999'
        }]
      }, {
        'label': 'Hourly',
        'value': 'hourly',
        'options': [{
          'label': '$0',
          'value': '0'
        }, {
          'label': '$15',
          'value': '15'
        }, {
          'label': '$20',
          'value': '20'
        }, {
          'label': '$25',
          'value': '25'
        }, {
          'label': '$30',
          'value': '30'
        }, {
          'label': '$35',
          'value': '35'
        }, {
          'label': '$40',
          'value': '40'
        }, {
          'label': '$50',
          'value': '50'
        }, {
          'label': '$60',
          'value': '60'
        }, {
          'label': '$75',
          'value': '75'
        }, {
          'label': '$100',
          'value': '100'
        }, {
          'label': '$100+',
          'value': '999999'
        }]
      }]
    },
    'dateRanges': [{
      'label': 'Any time',
      'value': '999'
    }, {
      'label': 'Today',
      'value': '1'
    }, {
      'label': 'Last 3 days',
      'value': '3'
    }, {
      'label': 'Last 7 days',
      'value': '7'
    }, {
      'label': 'Last 14 days',
      'value': '14'
    }, {
      'label': 'Last 30 days',
      'value': '31'
    }]
  };
};

exports.default = getTaxonomyByLocale();
var getByLocale = exports.getByLocale = function getByLocale(locale) {
  return getTaxonomyByLocale(locale);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/taxonomy.js
 ** module id = 445
 ** module chunks = 0
 **/